export default "__VITE_ASSET__DB1XpAZE__"